import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../reports.service'
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { Unit } from '../../common/models/Unit.Model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rep-adjust',
  templateUrl: './rep-adjust.component.html',
  styleUrls: ['./rep-adjust.component.scss']
})
export class RepAdjustComponent implements OnInit {

  constructor(private reportService: ReportsService,
    private globalFunctionService: GlobalFunctionsService) { }

  downloading: boolean = false;
  currentDate: Date;
  minDate: string;
  maxDate: string;
  today: string;
  unitSelectedId: number = 0;

  ngOnInit(): void {
    this.globalFunctionService.canOperate();
    this.globalFunctionService.hasFSBRPending();
    this.minDate = this.globalFunctionService.getStringDate(new Date, false, 0);
    this.maxDate = this.globalFunctionService.getStringDate(new Date, false, 0);
    this.today = this.globalFunctionService.getStringDate(new Date, false, 0);

    let org = 1;
    let userId = 0;
    let user = JSON.parse(localStorage.getItem("user"));
    if (user != null && user != undefined) {
      userId = user.Id
      org = user.Org;
    }
  }

  selectedUnitChange(unit: any): void {
    this.unitSelectedId = unit.UnitId;
  }

  unitCleared(): void {
    this.unitSelectedId = 0;
  }

  selectedFactory(fac: any): void {
    this.unitSelectedId = 0;
  }

  async download() {
    if (!this.validateFilters()) { return; }

    this.downloading = true;

    await this.downloadASReport();
    await this.downloadMultichannelReport();

    this.downloading = false;

  }

  downloadASReport(): Promise<void> {
    return this.reportService.downloadAdjustReport(this.unitSelectedId, this.minDate, this.maxDate)
      .toPromise()
      .then(resp => {
        console.log(resp);
        let blob = new Blob([resp], { type: resp.type });
        const anchor = document.createElement('a');
        anchor.download = `Reporte compulsa AS.xlsx`;
        anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
        anchor.click();
        anchor.remove();
      }, error => {
        console.log(error);
        this.globalFunctionService.messageToast(`Ocurrio un error al generar el reporte Auto Servicio, por favor vuelva a intentar.`, 'warning');
      });
  }

  downloadMultichannelReport(): Promise<void> {
    return this.reportService.downloadMultichannelAdjustReport(this.unitSelectedId, this.minDate, this.maxDate)
      .toPromise()
      .then(resp => {
        console.log(resp);
        let blob = new Blob([resp], { type: resp.type });
        const anchor = document.createElement('a');
        anchor.download = `Reporte compulsa Multicanal.xlsx`;
        anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
        anchor.click();
        anchor.remove();
      }, error => {
        console.log(error);
        this.globalFunctionService.messageToast(`Ocurrio un error al generar el reporte Multicanal, por favor vuelva a intentar.`, 'warning');
      });
  }

  validateFilters(): boolean {
    if (this.minDate == "") {
      this.globalFunctionService.messageToast(`Se debe especificar la fecha inicial.`, 'warning');
      return false;
    }
    if (this.maxDate == "") {
      this.globalFunctionService.messageToast(`Se debe especificar la fecha final.`, 'warning');
      return false;
    }

    if (new Date(this.maxDate) < new Date(this.minDate)) {
      this.globalFunctionService.messageToast(`La fecha inicial no puede ser mayor a la fecha final.`, 'warning');
      return false;
    }

    return true;
  }

}
